import React from 'react';
import { BoxIcon } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string | number;
  icon: BoxIcon;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  color?: 'blue' | 'green' | 'purple' | 'orange';
}
export function StatCard({
  title,
  value,
  icon: Icon,
  trend,
  color = 'blue'
}: StatCardProps) {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400',
    green: 'bg-green-50 text-green-700 dark:bg-green-900/20 dark:text-green-400',
    purple: 'bg-purple-50 text-purple-700 dark:bg-purple-900/20 dark:text-purple-400',
    orange: 'bg-orange-50 text-orange-700 dark:bg-orange-900/20 dark:text-orange-400'
  };
  return <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-6 transition-all hover:shadow-md" data-id="element-2611">
      <div className="flex items-center justify-between" data-id="element-2612">
        <div className="min-w-0 flex-1 mr-4" data-id="element-2613">
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400 truncate" data-id="element-2614">
            {title}
          </p>
          <p className="mt-2 text-3xl font-bold text-gray-900 dark:text-white break-all" data-id="element-2615">
            {value}
          </p>
        </div>
        <div className={`p-3 rounded-lg flex-shrink-0 ${colorClasses[color]}`} data-id="element-2616">
          <Icon className="h-6 w-6" data-id="element-2617" />
        </div>
      </div>
      {trend && <div className="mt-4 flex items-center text-sm flex-wrap gap-2" data-id="element-2618">
          <span className={`font-medium whitespace-nowrap ${trend.isPositive ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`} data-id="element-2619">
            {trend.isPositive ? '+' : ''}
            {trend.value}%
          </span>
          <span className="text-gray-500 dark:text-gray-400 truncate" data-id="element-2620">
            from last month
          </span>
        </div>}
    </div>;
}